module.exports = __webpack_public_path__ + "static/img/3a.f478378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3a.jpg
// module id = CABN
// module chunks = 0